module.exports = __webpack_public_path__ + "static/media/pauseActive.b15d526f.svg";